/**
 * The dashboard's view lives in the URL hash as '#90d' or '#90d-meta', the
 * same token the page itself writes. The shell mirrors it so a link to /ads
 * opens the view the sender was looking at.
 */

export const RANGE_KEYS = ['today', '3d', '7d', '14d', '30d', '90d', 'all'] as const;
export const CHANNEL_KEYS = ['all', 'meta', 'ig', 'google'] as const;

export type RangeKey = (typeof RANGE_KEYS)[number];
export type ChannelKey = (typeof CHANNEL_KEYS)[number];
export interface AdsView { range: RangeKey; channel: ChannelKey }

export const DEFAULT_VIEW: AdsView = { range: '90d', channel: 'all' };

export function parseHash(hash: string): AdsView {
  const raw = (hash || '').replace(/^#/, '').trim();
  if (!raw) return DEFAULT_VIEW;
  const parts = raw.split('-');
  const range = RANGE_KEYS.find((r) => r === parts[0]);
  const channel = CHANNEL_KEYS.find((c) => c === parts[1]);
  return { range: range || DEFAULT_VIEW.range, channel: channel || DEFAULT_VIEW.channel };
}

export function buildHash(view: AdsView): string {
  return view.channel && view.channel !== 'all' ? `${view.range}-${view.channel}` : view.range;
}

export function isSameView(a: AdsView, b: AdsView): boolean {
  return a.range === b.range && a.channel === b.channel;
}
